<style scoped>
.control-panel-block {
    -webkit-transition: max-height .5s, padding .5s;
    transition: max-height .5s, padding .5s;
    max-height: 0;
    overflow: hidden;
    margin-top: 20px;
}

.faucets-block {
    border-right: 1px solid #526170;
}

.history-devices-button-block,
.system-actions-checkbox-block,
.system-actions-label-text {
    padding: 20px 0;
}

.control-panel-block.open {
    max-height: 2000px;
    -webkit-animation: delay-overflow .5s;
    animation: delay-overflow .5s forwards;
}

@keyframes delay-overflow {
    99% {
        overflow: hidden;
    }

    100% {
        overflow: visible;
    }
}

.options-btn-block {
    text-align: center;
}

.filter-icon {
    background-color: #526170;
    height: 30px;
    float: left;
    width: 30px;
    margin: 0 5px;
    cursor: pointer;
    margin-left: 30px;
}

.loader-block {
    padding-top: 150px;
}

.group-devicess-checkbox-block {
    margin: 10px 0;
}

.group-devicess-checkbox-block p {
    color: #77899b;
}

.faucet-block,
.sensor-block {
    margin: 5px 0;
}

.faucet-block p,
.sensor-block p {
    margin: 5px 0;
}

.control-panel-block .date-select-block.active {
    border-bottom: 2px solid #0098dc;
    -webkit-box-shadow: 0 5px 2px -4px #00a6ec;
    box-shadow: 0 5px 2px -4px #00a6ec;
}

.date-select-block .by-text {
    margin-left: 25px;
}

.control-panel-block .date-select-block {
    padding-top: 10px;
}
</style>

<template>
<div class="col-12 history-page">
    <div class="row">
        <div class="col-2 options-btn-block">
            <div class="filter-icon icon" :class="{'active': view_control_panel}" @click="changeControlPanelStatus()"></div>
        </div>
        <div class="col-8 tabs-history-menu" :class="{'open': view_control_panel}">
            <a href="#">
                <div class="menu-tab" 
                :class="{'active': time_action == '1hour'}"
                @click="changeDatePeriod('1hour')">1 час</div>
            </a>
            <a href="#">
                <div class="menu-tab"  
                :class="{'active': time_action == '3hour'}"
                @click="changeDatePeriod('3hour')">3 часа</div>
            </a>
            <a href="#">
                <div class="menu-tab"  
                :class="{'active': time_action == '6hours'}"
                @click="changeDatePeriod('6hours')">6 часов</div>
            </a>
            <a href="#">
                <div class="menu-tab" 
                :class="{'active': time_action == '1day'}"
                @click="changeDatePeriod('1day')">1 сутки</div>
            </a>
            <a href="#">
                <div class="menu-tab"  
                :class="{'active': time_action == '3day'}"
                @click="changeDatePeriod('3day')">3 суток</div>
            </a>
            <a href="#">
                <div class="menu-tab"  
                :class="{'active': time_action == 'week'}"
                @click="changeDatePeriod('week')">неделя</div>
            </a>
        </div>
        <div class="col-2">
            <div class="table_grid icon" :class="{'active': view_element == 'table'}" @click="view_element = 'table'"></div>
            <div class="line_chart icon" :class="{'active': view_element == 'chart'}" @click="view_element = 'chart'"></div>
        </div>

        <div class="col-12 control-panel-block" :class="{'open': view_control_panel}">
            <div class="row">
                <div class="offset-3 col-6 date-select-block" :class="{'active': time_action == 'free_period'}">
                    <div class="row">
                        <div class="col-1">
                            <p>с</p>
                        </div>
                        <div class="col-4 aquazor-selector">
                            <div class="aquazor-calendar">
                                <vuejs-datepicker :language="datepicker_languages[datepicker_lang]" :format="'dd-MM-yyyy'" :monday-first="true" v-model="start_period_date"></vuejs-datepicker>
                            </div>
                        </div>
                        <div class="col-2">
                            <p class="by-text">по</p>
                        </div>
                        <div class="col-5 aquazor-selector">
                            <div class="aquazor-calendar">
                                <vuejs-datepicker :language="datepicker_languages[datepicker_lang]" :format="'dd-MM-yyyy'" :monday-first="true" v-model="end_period_date"></vuejs-datepicker>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="offset-1 col-1 system-actions-checkbox-block">
          <input style="display: inline-block; top: 0;" id="system-actions" checked="checked" type="checkbox" autocomplete="off">
          <label class="system-actions" for="system-actions">.</label>
        </div> -->
                <!-- <div class="col-4 system-actions-label-text">
          <p>Системные события</p>
        </div> -->
                <div class="col-12 group-devicess-checkbox-block">
                    <div class="row">
                        <div class="col-6 faucets-block">
                            <div class="row faucet-block" v-for="(faucet, index) in faucets" :key="index">
                                <div class="col-2">
                                    <input style="display: inline-block; top: 0;" :id="getIdForFaucetCheckbox(index)"
                  v-model="faucet.status" type="checkbox" autocomplete="off"
                  @change="checkFaucets()">
                                    <label class="system-actions" :for="getIdForFaucetCheckbox(index)">.</label>
                                </div>
                                <div class="col-10">
                                    <p>{{faucet.name}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 sensors-block">
                            <div class="row sensor-block" v-for="(sensor, index) in sensors" :key="index">
                                <div class="col-2">
                                    <input style="display: inline-block; top: 0;" :id="getIdForSensorCheckbox(index)"
                  v-model="sensor.status"
                  @change="checkSensors()"
                  type="checkbox" autocomplete="off" >
                                    <label class="system-actions" :for="getIdForSensorCheckbox(index)" >.</label>
                                </div>
                                <div class="col-10">
                                    <p>{{sensor.name}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" v-if="!loader && change_filter">
        <chart-component v-if="view_element == 'chart'" :data="getFilterData()"></chart-component>
        <statuses-component v-if="view_element == 'table'" :data="getFilterData()"></statuses-component>
    </div>
    <div class="loader-block" v-if="loader">
        <loader-component></loader-component>
    </div>
</div>
</template>

<script>
import history_chart from './elements/history_chart'
import history_statuses from './elements/history_statuses'
import Datepicker from 'vuejs-datepicker'
import '@/assets/css/calendar.css'
import * as lang from "vuejs-datepicker/src/locale"
import loader from './elements/loader.vue'
import axios from 'axios'
import config from '@/config.js'

export default {
    name: 'vue-line-chart',
    data() {
        return {
            view_element: 'table',
            view_control_panel: false,
            date: null,
            datepicker_lang: 'ru',
            datepicker_languages: lang,
            loader: true,
            sensors: [],
            faucets: [],
            change_filter: true,
            start_period_date: null,
            end_period_date: null,
            time_action: '1day',
            change_filter_action_code: 0,
            timezone_data: null,
            get_group_faucets_and_sensors_status: false
        }
    },
    mounted() {
        get_group_faucets_and_sensors(this)
        get_group_timezone(this)
    },
    methods: {
        changeControlPanelStatus: function () {
            this.view_control_panel = this.view_control_panel ? false : true
        },
        getIdForFaucetCheckbox: function (index) {
            return 'faucet-chckbox-' + index
        },
        getIdForSensorCheckbox: function (index) {
            return 'sensor-chckbox-' + index
        },
        checkSensors: function () {
            this.changeFilter(3000)
        },
        checkFaucets: function () {
            this.changeFilter(3000)
        },
        changeFilter: function (wait) {
            var timeout = 100
            if (!!wait) {
                timeout = wait
            }
            this.change_filter = false
            this.loader = true
            this.change_filter_action_code += 1
            var inside_change_filter_action_code = this.change_filter_action_code
            setTimeout(() => {
                if (inside_change_filter_action_code == this.change_filter_action_code) {
                    this.change_filter = true
                    this.loader = false
                }
            }, timeout)
        },
        getFilterData: function () {
            if (this.time_action == '1day' || this.time_action == '3day' || this.time_action == 'week' ||
                this.time_action == '1hour' || this.time_action == '3hour' || this.time_action == '6hours') {
                var date = new Date()
                // date.setSeconds(-get_utc_difference())
                // date.setSeconds(this.timezone_data.offset * 60 * 60)
                var end_time = date.getTime()
                if (this.time_action == '1day') {
                    date.setDate(date.getDate() - 1)
                } else if (this.time_action == '3day') {
                    date.setDate(date.getDate() - 3)
                } else if (this.time_action == 'week') {
                    date.setDate(date.getDate() - 7)
                } else if (this.time_action == '1hour') {
                    date.setHours(date.getHours() - 1)
                } else if (this.time_action == '3hour') {
                    date.setHours(date.getHours() - 3)
                } else if (this.time_action == '6hours') {
                    date.setHours(date.getHours() - 6)
                }
                var start_time = date.getTime()
            } else if (this.time_action == 'free_period') {
                var start_time_date = this.start_period_date
                start_time_date.setHours(0)
                start_time_date.setMinutes(0)
                start_time_date.setSeconds(0)
                var start_time = start_time_date.getTime()

                var end_time_date = this.end_period_date
                if (start_time > end_time_date.getTime()) {
                    this.end_period_date = start_time_date
                    end_time_date = this.end_period_date
                }

                end_time_date.setHours(23)
                end_time_date.setMinutes(59)
                end_time_date.setSeconds(59)
                var end_time = end_time_date.getTime()
            }

            var sensors_ids = []
            this.sensors.forEach(sensor => {
                console.log(sensor.status)
                if (sensor.status == true) {
                    sensors_ids.push(sensor.id)
                }
            })

            var faucets_ids = []
            this.faucets.forEach(faucet => {
                console.log(faucet.status)
                if (faucet.status == true) {
                    faucets_ids.push(faucet.id)
                }
            })
            var data = {
                faucets: faucets_ids,
                sensors: sensors_ids,
                start_time: start_time,
                end_time: end_time,
                offset_time: this.timezone_data.offset
            }
            return data
        },
        changeDatePeriod: function (action) {
            if (action == 'free_period') {
                if (this.start_period_date !== null && this.end_period_date != null) {
                    this.time_action = action
                    this.changeFilter()
                }
            } else {
                this.time_action = action
                this.changeFilter()
            }
        }
    },
    components: {
        'chart-component': history_chart,
        'statuses-component': history_statuses,
        'vuejs-datepicker': Datepicker,
        'loader-component': loader,
    },
    watch: {
        start_period_date: function (this_period_date, old_period_date) {
            this.changeDatePeriod('free_period')
        },
        end_period_date: function (this_period_date, old_period_date) {
            this.changeDatePeriod('free_period')
        }
    }
}

function get_group_faucets_and_sensors(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_group', vue_obj.$route.params.id_group)
        axios({
                method: 'POST',
                url: config.API_HOST + '/groups/get_group_faucets_and_sensors',
                data: post_data
            })
            .then(function (response) {
                if (response.data.faucets) {
                    vue_obj.faucets = response.data.faucets
                    vue_obj.faucets.forEach(faucet => {
                        faucet.status = true
                    });
                }
                if (response.data.sensors) {
                    vue_obj.sensors = response.data.sensors
                    vue_obj.sensors.forEach(sensor => {
                        sensor.status = true
                    });
                }
                vue_obj.get_group_faucets_and_sensors_status = true
                check_load_data(vue_obj)
            })
            .catch(function (error) {

            })
    }
}

function get_group_timezone(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_group', vue_obj.$route.params.id_group)
        axios({
                method: 'POST',
                url: config.API_HOST + '/groups/get_timezone',
                data: post_data
            })
            .then(function (response) {
                if (response.data.timezone_data) {
                    vue_obj.timezone_data = response.data.timezone_data
                }
                check_load_data(vue_obj)
            })
            .catch(function (response) {
                console.log(response)
            })
    }
}

function check_load_data(vue_obj) {
    if (!!vue_obj.timezone_data && !!vue_obj.get_group_faucets_and_sensors_status)
        vue_obj.loader = false
}

function get_utc_difference() {
    var date = new Date;
    var utc_date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    return Math.floor((date.getTime() - utc_date.getTime()))
}
</script>



// WEBPACK FOOTER //
// src/components/history.vue